import VoletReno from 'assets/img/volet-reno.png';
import VoletTradi from 'assets/img/volet-tradi.png';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import droite from 'assets/img/stock/droite.png';
import gauche from 'assets/img/stock/gauche.png';

import battant from 'assets/img/battant.png';
import coulissant from 'assets/img/coulissant.png';
const couleur = {
	id: 'VR-TR-TB-CC',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'couleur',
	classGroup: 'Simulateur_color',
	label: 'Couleur',
	defaultValue: 0,
	nextStep: false,
	options: [
		{
			id: 6,
			label: 'Blanc RAL 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 6,
			description: '- Finition blanc RAL 9016, aspect clair et moderne.',
		},
		{
			id: 14,
			label: 'Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 14,
			description: '- Finition gris anthracite RAL 7016, style contemporain.',
		},
		{
			id: 104,
			label: 'Noir',
			color: '#000000',
			icon: 'CustomCircle',
			value: 104,
			description: '- Finition noire, élégante et sobre.',
		},
	],
};

const poids = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'Poids',
	className: 'col-6',
	label: 'Poids',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: couleur,
	validation: (value) => {
		return value > 0;
	},
};
const largeur = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeur',
	className: 'col-6',
	label: 'Largeur (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: poids,
	validation: (value) => {
		return value > 0;
	},
};
const hauteur = {
	id: 'VR-TR-VRC-H',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteur',
	className: 'col-6',
	label: 'Hauteur  (mm)',
	defaultValue: 0,
	placeholder: '0',
	nextStepData: largeur,
	validation: (value) => {
		return value > 0;
	},
};

const typeManoeuvre = {
	id: 'VR-TR-VRC-TM',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeManoeuvre',
	className: 'col-6',
	label: 'Manouvre',
	nextStepData: false,
	options: [
		{
			id: 'VR-TR-VRC-TM-MNU',
			label: 'Manuel',
			value: 'Manuel',
			imageUrl: ManoeuvreManuel,
			nextStep: hauteur,
			description: '- Manœuvre manuelle du portail (sans motorisation).',
		},
		{
			id: 'VR-TR-VRC-TM-ELE',
			label: 'Motorisé',
			value: 'Motorisé',
			imageUrl: ManoeuvreElectrique,
			nextStep: hauteur,
			description: '- Manœuvre motorisée du portail (prévu pour motorisation électrique).',
		},
	],
};
const PortailData = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type',
	name: 'Type',
	className: 'col-12',
	classGroup: 'Type',
	nextStep: false,
	options: [
		{
			id: 'Battant',
			label: 'Battant',
			value: 'Battant',
			imageUrl:battant,
			description: "Fourniture d'un Portail à ouverture battante (un ou deux vantaux).",
			nextStep: typeManoeuvre,
		},
		{
			id: 'Coulissant',
			label: 'Coulissant',
			value: 'Coulissant',
			description: "Fourniture d'un Portail à ouverture coulissante latérale.",
			nextStep: typeManoeuvre,
			imageUrl:coulissant
		},
	],
};

export default PortailData;
